<template lang="jade">
  aside#landing-bg(v-bind:style="{ backgroundImage: 'url(' + background + ')' }")
</template>

<script>
  export default {
    data () {
      return {
        background: 'imgs/bg/shasta-bg.jpg',
      }
    }
  }

  setTimeout(function() {
    document.querySelector('#landing-bg').style.opacity = 1;
  }, 500);

</script>

<style lang="sass?indentedSyntax" scoped>
  
  @import "../_sass/utilities/_utilities.sass"

  aside#landing-bg
    @extend %full-screen
    @extend %full-bg
    @extend %smooth-slow
    position: fixed
    top: 0
    left: 0
    z-index: 1
    opacity: 0
    display: block

</style>


/** WEBPACK FOOTER **
 ** Background.vue?960fba48
 **/